import React, { createContext, useContext, useState } from 'react';
import { SportTabKey } from '../utils/sportTabs';

interface TurfContextType {
  currentTurfLogo: string | null;
  setCurrentTurfLogo: (logo: string | null) => void;
  availableSportTabs: SportTabKey[];
  setAvailableSportTabs: (tabs: SportTabKey[]) => void;
}

const TurfContext = createContext<TurfContextType | undefined>(undefined);

export const TurfProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentTurfLogo, setCurrentTurfLogo] = useState<string | null>(null);
  // Populated by the listing pages so the header can render only the sport tabs
  // that the city (or area) actually has turfs for.
  const [availableSportTabs, setAvailableSportTabs] = useState<SportTabKey[]>([]);

  return (
    <TurfContext.Provider
      value={{
        currentTurfLogo,
        setCurrentTurfLogo,
        availableSportTabs,
        setAvailableSportTabs,
      }}
    >
      {children}
    </TurfContext.Provider>
  );
};

export const useTurfContext = () => {
  const context = useContext(TurfContext);
  if (!context) {
    throw new Error('useTurfContext must be used within a TurfProvider');
  }
  return context;
}; 
